export function U2000GeneratePassword(pwdLength: number = 8, includeSymbols: boolean = true): string {
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const digits = "0123456789";
  const symbols = "!@#$%^&*";

  // Construire les pools selon les options
  const pools: string[] = [lower, upper, digits];
  if (includeSymbols) pools.push(symbols);

  const all = pools.join("");

  // Nombre minimum requis (une par catégorie activée)
  const minRequired = pools.length;
  if (pwdLength < minRequired) pwdLength = minRequired;

  const passwordChars: string[] = [];

  // Helpers pour index aléatoire — utilise crypto si disponible
  const getRandomInt = (max: number) => {
    if (typeof globalThis !== "undefined" && "crypto" in globalThis && typeof globalThis.crypto.getRandomValues === "function") {
      const array = new Uint32Array(1);
      globalThis.crypto.getRandomValues(array);
      return array[0] % max;
    }
    return Math.floor(Math.random() * max);
  };

  const pick = (pool: string) => pool[getRandomInt(pool.length)];

  // Garantir la présence d'au moins un caractère de chaque type activé
  passwordChars.push(pick(lower));
  passwordChars.push(pick(upper));
  passwordChars.push(pick(digits));
  if (includeSymbols) passwordChars.push(pick(symbols));

  // Remplir le restant avec des caractères aléatoires depuis l'ensemble complet
  for (let i = passwordChars.length; i < pwdLength; i++) {
    passwordChars.push(pick(all));
  }

  // Mélange Fisher–Yates (utilise getRandomInt)
  for (let i = passwordChars.length - 1; i > 0; i--) {
    const j = getRandomInt(i + 1);
    const tmp = passwordChars[i];
    passwordChars[i] = passwordChars[j];
    passwordChars[j] = tmp;
  }

  return passwordChars.join("");
}
